import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ClientNutritionWeek } from "@fitness-app/data-models/entities/ClientNutritionWeek";
import { getIsoWeekKey } from "@fitness-app/utils/src/dates/getIsoWeekKey";

import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_MEASUREMENTS_REDUCER_NAME } from "../types";

type Payload = {
  traineeId: string;
  dateStart: Date;
  dateEnd: Date;
};

export const fetchNutritionSummaryForRange = createAsyncThunk<
  ClientNutritionWeek[],
  Payload,
  AsyncThunkCreator<string>
>(
  `${TRAINEE_MEASUREMENTS_REDUCER_NAME}/fetchNutritionSummaryForRange`,
  async ({ traineeId, dateStart, dateEnd }, { rejectWithValue, extra: { db } }) => {
    // "2026-53" < "2027-01" as strings, so the range holds across New Year.
    const startWeek = getIsoWeekKey(dateStart);
    const endWeek = getIsoWeekKey(dateEnd);

    const { error, data } = await db
      .from("client_nutrition_week")
      .select("*")
      .order("eventWeekIso")
      .eq("traineeId", traineeId)
      .gte("eventWeekIso", startWeek)
      .lte("eventWeekIso", endWeek)
      .returns<ClientNutritionWeek[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data || [];
  },
);
